import { Link } from "react-router-dom";
import Logo from "../../../assets/icons/ASBLogo.png";

export const ASBLogo = () => {
  return (
    <Link to="/" className="header__krk">
      <img  src={Logo} alt="Логотип"></img>
    </Link>
  );
};
